import "./services.css";

import React from "react";
import { Link } from "react-router-dom";

import { ROUTES, SERVICES } from "../../data/content";
import PageMeta from "../general/PageMeta";

const Services = () => {
  return (
    <section
      className={"services-page"}
      style={{ backgroundImage: "url(/images/services/bg-services.webp)" }}
    >
      <PageMeta title={"Our Services"} />
      <div className={"services-page-inner container"}>
        <h1 className={"visually-hidden"}>Our Services</h1>
        <ul className={"services-grid"}>
          {SERVICES.map((service) => (
            <li key={service.path}>
              <Link
                to={service.path}
                className={"service-tile"}
              >
                <img
                  src={service.tile}
                  alt={service.tileAlt}
                  width={640}
                  height={480}
                />
                <span className={"service-tile-label"}>{service.name}</span>
              </Link>
            </li>
          ))}
        </ul>

        <div className={"services-else"}>
          <h2 className={"services-else-title"}>Looking for something else?</h2>
          <span className={"title-rule is-yellow"} />
          <Link
            to={ROUTES.CONTACT}
            className={"btn btn-light"}
          >
            Contact us today!
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
